/// <reference path="../generated/MitgliedschaftAntragsstellerApi.d.ts"/>
import { AppUtils } from '../../utils/index';
import { AdvertisingConsentModel } from '../view/AdvertisingConsent';
import { PersonalDataModel } from '../view/PersonalData';
import { BankdatenModel } from '../view/Bankdaten';
import { AdresseModel } from '../view/Adresse';
import { AbwKontoInhaberModel } from '../view/AbwKontoInhaber';
import { FahrzeugModel } from '../view/Fahrzeug';
import { WerbeZustimmungModel } from '../view/WerbeZustimmung';
import { AntragsstellerApi } from '../generated/MitgliedschaftAntragsstellerApi';
import { AddressApi as PersonAddressApi } from '../generated/PersonAddressApi';
import { PrivacyApi } from '../generated/PersonPrivacyApi';
import { ConsentWriteShortModelApi } from '../generated/ModelsConsentWriteShortModelApi';
import { ConsentManagementEmailAddressApi } from '../generated/ModelsConsentManagementEmailAddressApi';
import { ConsentManagementPhoneApi } from '../generated/ModelsConsentManagementPhoneApi';
import { PhoneApi } from '../generated/PersonPhoneApi';
import { PrivacyAcceptanceApi } from '../generated/PersonPrivacyAcceptanceApi';
import { AbweichenderKontoInhaberApi } from '../generated/PersonAbweichenderKontoInhaberApi';
import { BankApi } from '../generated/PersonBankApi';
import { MeinFahrzeugDetailApi } from '../generated/FahrzeugeMeinFahrzeugDetailApi';
import { KennzeichenApi } from '../generated/FahrzeugdatenKennzeichenApi';
import { MitgliedschaftanlagedatenApi } from '../generated/VersicherungMitgliedschaftanlagedatenApi';
import { MglArtApi } from '../generated/PersonMglArtApi';
import { MembershipSelectionType } from '../view/MembershipSelectionType';
import { AnredeArtApi } from '../generated/InterfacesAnredeArtApi';

/**
 * Converts insurance view models to api models and vice versa.
 */
export class ModelAdapter {

	/**
	 * Converts a api model to an view model.
	 */
	static getFahrzeugModel(fahrzeugModelApi: MeinFahrzeugDetailApi): FahrzeugModel {
		const fahrzeugModel = new FahrzeugModel();

		fahrzeugModel.FahrzeugTitel = fahrzeugModelApi.Name;
		fahrzeugModel.Karosserievariante = fahrzeugModelApi.Karosserie;
		fahrzeugModel.AuslOderDiplomat = fahrzeugModelApi.IstNichtDeutschesKennzeichen || false;
		fahrzeugModel.KennzeichenPrefix = fahrzeugModelApi.Zulassung && fahrzeugModelApi.Zulassung.Kreis ? fahrzeugModelApi.Zulassung.Kreis : '';
		fahrzeugModel.KennzeichenSuffix = fahrzeugModelApi.Zulassung && fahrzeugModelApi.Zulassung.Nummer ? fahrzeugModelApi.Zulassung.Nummer : '';
		fahrzeugModel.Fahrzeugart = fahrzeugModelApi.Typ;
		fahrzeugModel.Marke = fahrzeugModelApi.Marke;
		fahrzeugModel.MarkeId = fahrzeugModelApi.MarkeId ? fahrzeugModelApi.MarkeId.toString() : null;
		fahrzeugModel.Baureihe = fahrzeugModelApi.Baureihe;
		fahrzeugModel.BaureiheId = fahrzeugModelApi.BaureiheId ? fahrzeugModelApi.BaureiheId.toString() : null;
		fahrzeugModel.Modell = fahrzeugModelApi.Modell;
		fahrzeugModel.ModellId = fahrzeugModelApi.ModellVarianteId ? fahrzeugModelApi.ModellVarianteId.toString() : null;
		fahrzeugModel.FahrzeugBezeichnung = fahrzeugModelApi.FahrzeugBezeichnung;
		fahrzeugModel.Schadstoffklasse = fahrzeugModelApi.EuroNorm;
		fahrzeugModel.Verbrauch = fahrzeugModelApi.Verbrauch;
		fahrzeugModel.Farbe = fahrzeugModelApi.FahrzeugFarbe;
		fahrzeugModel.Kraftstoff = fahrzeugModelApi.Kraftstoff;
		fahrzeugModel.KfzId = fahrzeugModelApi.Id;
		fahrzeugModel.BaureiheGeneration = fahrzeugModelApi.BaureiheGeneration;
		fahrzeugModel.BaureiheGenerationId = fahrzeugModelApi.BaureiheGenerationId ? fahrzeugModelApi.BaureiheGenerationId.toString() : null;
		fahrzeugModel.TetId = fahrzeugModelApi.DataSourceRef;

		return fahrzeugModel;
	}

	/**
	 * Converts a view model to an view model.
	 */
	static getFahrzeugModelApi(fahrzeugModel: FahrzeugModel): MeinFahrzeugDetailApi {
		const fahrzeugModelApi = new MeinFahrzeugDetailApi();
		fahrzeugModelApi.Zulassung = new KennzeichenApi();

		if (fahrzeugModel.ID) {
			fahrzeugModelApi.ReferenceId = fahrzeugModel.ID;
		}

		if (fahrzeugModel.KfzId) {
			fahrzeugModelApi.Id = fahrzeugModel.KfzId;
		}
		if (fahrzeugModel.IsManuallyChanged || !fahrzeugModel.KfzId) {
			if (!isNaN(fahrzeugModel.Verbrauch)) {
				fahrzeugModelApi.Verbrauch = Number(fahrzeugModel.Verbrauch);
			}
			fahrzeugModelApi.Kraftstoff = fahrzeugModel.Kraftstoff;
			fahrzeugModelApi.Marke = fahrzeugModel.Marke;
			if (isNaN(fahrzeugModel.MarkeId as any)) {
				fahrzeugModelApi.MarkeId = Number(fahrzeugModel.MarkeId);
			}
			fahrzeugModelApi.Baureihe = fahrzeugModel.Baureihe;
			fahrzeugModelApi.Modell = fahrzeugModel.Modell;
			if (!isNaN(fahrzeugModel.ModellId as any)) {
				fahrzeugModelApi.ModellVarianteId = Number(fahrzeugModel.ModellId);
			}
			fahrzeugModelApi.Karosserie = fahrzeugModel.Karosserievariante;
		}

		fahrzeugModelApi.Name = fahrzeugModel.FahrzeugTitel;
		fahrzeugModelApi.IstNichtDeutschesKennzeichen = fahrzeugModel.AuslOderDiplomat || false;

		if (fahrzeugModel.KennzeichenPrefix !== "") {
			fahrzeugModelApi.Zulassung.Kreis = fahrzeugModel.KennzeichenPrefix;
		}
		if (fahrzeugModel.KennzeichenSuffix !== "") {
			fahrzeugModelApi.Zulassung.Nummer = fahrzeugModel.KennzeichenSuffix;
		}

		fahrzeugModelApi.Typ = fahrzeugModel.Fahrzeugart;
		fahrzeugModelApi.EuroNorm = fahrzeugModel.Schadstoffklasse;
		fahrzeugModelApi.FahrzeugFarbe = fahrzeugModel.Farbe;
		fahrzeugModelApi.BaureiheGeneration = fahrzeugModel.BaureiheGeneration;
		fahrzeugModelApi.BaureiheGenerationId = Number(fahrzeugModel.BaureiheGenerationId);
		fahrzeugModelApi.FahrzeugBezeichnung = fahrzeugModel.FahrzeugBezeichnung;

		if (fahrzeugModel.TetId) {
			fahrzeugModelApi.DataSourceRef = fahrzeugModel.TetId;
		}
		return fahrzeugModelApi;
	}

	/**
	   * Converts a view model to an api model.
	   */
	static getAbweichenderKontoInhaberApi(abwKontoInhaber: AbwKontoInhaberModel): AbweichenderKontoInhaberApi {
		// models are compatible, so just create from object
		const abwKontoInhaberApi = new AbweichenderKontoInhaberApi();

		abwKontoInhaberApi.Vorname = abwKontoInhaber.Vorname;
		abwKontoInhaberApi.Name = abwKontoInhaber.Name;
		abwKontoInhaberApi.Titel = abwKontoInhaber.Titel;
		abwKontoInhaberApi.AnredeKennzeichen = abwKontoInhaber.AnredeKennzeichen;
		abwKontoInhaberApi.Adresse = this.getAddressApi(abwKontoInhaber.Adresse);
		return abwKontoInhaberApi;
	}

	/**
	 * Converts view models to an api model.
	 */
	static getAntragsstellerApi(personalData: PersonalDataModel): AntragsstellerApi {
		const antragssteller = new AntragsstellerApi();
		antragssteller.Anrede = personalData.AnredeKennzeichen ? personalData.AnredeKennzeichen : AnredeArtApi.None;
		antragssteller.Titel = personalData.Titel;
		antragssteller.Anschrift = ModelAdapter.getAddressApi(personalData.Adresse);
		antragssteller.Beguenstigter = personalData.Beguenstigter;
		antragssteller.Email = personalData.Email;
		antragssteller.Firma = personalData.Firma;
		antragssteller.Geburtsdatum = AppUtils.Format.viewDateToIsoDate(personalData.Geburtsdatum);
		antragssteller.Nachname = personalData.Nachname;
		antragssteller.TelGesch = ModelAdapter.getPhoneApi(personalData.TelefonGeschaeftlichVorwahl, personalData.TelefonGeschaeftlichNummer);
		antragssteller.Telefon = ModelAdapter.getPhoneApi(personalData.TelefonVorwahl, personalData.TelefonNummer);
		antragssteller.Vorname = personalData.Vorname;
		return antragssteller;
	}

	/**
	 * Converts an api model to a view model.
	 */
	static getAdresseModel(adresse: AddressApi): AdresseModel {
		const result = new AdresseModel();
		result.Ergaenzungszeile = adresse.Ergaenzungszeile;
		result.Ort = adresse.Ort;
		result.Postleitzahl = adresse.Postleitzahl;
		result.StrasseHausnummer = adresse.StrasseHausnummer;
		return result;
	}

	/**
	 * Converts a view model to an api model.
	 */
	static getAddressApi(adresse: AdresseModel): PersonAddressApi {
		const result = new PersonAddressApi();
		result.Ergaenzungszeile = adresse.Ergaenzungszeile;
		result.Ort = adresse.Ort;
		result.Postleitzahl = adresse.Postleitzahl;
		result.StrasseHausnummer = adresse.StrasseHausnummer;
		result.Postfachnummer = adresse.Postfachnummer;
		return result;
	}

	/**
	 * Converts a view model to an api model.
	 */
	static getPrivacyApi(werbeEinwilligungen: AdvertisingConsentModel): PrivacyApi {
		const privacyModel = new PrivacyApi();
		if (werbeEinwilligungen !== null && werbeEinwilligungen !== undefined) {
			privacyModel.Einwilligung = werbeEinwilligungen.Einwilligung;
			privacyModel.Email = werbeEinwilligungen.Email;
			privacyModel.Telefon = werbeEinwilligungen.Telefon;
			privacyModel.TimeStamp = werbeEinwilligungen.TimeStamp;
		}
		return privacyModel;
	}

	/**
	 * Converts a view model to an api model.
	 */
	static getPrivacyApiFromAdvertisingConsent(formModel: AdvertisingConsentModel, herkunftsKnz: string, version: string): PrivacyApi {
		const requestModel = new PrivacyApi();
		if (formModel !== null && formModel !== undefined) {
			requestModel.Einwilligung = formModel.Einwilligung;
			requestModel.Email = formModel.Email;
			requestModel.Telefon = formModel.Telefon;
			requestModel.TimeStamp = formModel.TimeStamp;

			if (version && version.length > 0) {
				requestModel.Version = Number(version);
			}

			if (herkunftsKnz !== undefined && herkunftsKnz.length > 0) {
				requestModel.HerkunftsKnz = herkunftsKnz;
			} else {
				requestModel.HerkunftsKnz = formModel.HerkunftsKz;
			}
			if (requestModel.HerkunftsKnz !== undefined) {
				requestModel.HerkunftsKnz = requestModel.HerkunftsKnz.substr(0, 8);
			}
		}
		return requestModel;
	}

	/**
	 * Converts a view model to an api model.
	 */
	static getConsentWriteShortModelApi(formModel: AdvertisingConsentModel, personalDataModel: PersonalDataModel, herkunftsKnz: string, version: string): ConsentWriteShortModelApi {
		const requestModel = new ConsentWriteShortModelApi();
		if (formModel !== null && formModel !== undefined) {
			requestModel.IpAddress = formModel.UserIp;

			if (herkunftsKnz !== undefined && herkunftsKnz.length > 0) {
				requestModel.Herkunftskennzeichen = herkunftsKnz;
			} else {
				requestModel.Herkunftskennzeichen = formModel.HerkunftsKz;
			}

			if (formModel.Email) {
				requestModel.ChannelEmail = new ConsentManagementEmailAddressApi({ Email: personalDataModel.Email, Authorized: true });
			}

			if (formModel.Telefon) {
				requestModel.ChannelTel1 = new ConsentManagementPhoneApi({
					Telefon: this.getPhoneApi(personalDataModel.TelefonVorwahl, personalDataModel.TelefonNummer),
					Authorized: true
				});
			}

			if (formModel.Telefon2) {
				requestModel.ChannelTel2 = new ConsentManagementPhoneApi({
					Telefon: this.getPhoneApi(personalDataModel.TelefonGeschaeftlichVorwahl, personalDataModel.TelefonGeschaeftlichNummer),
					Authorized: true
				});
			}

			if (version && version.length > 0) {
				requestModel.Version = version;
			}
			if (formModel.Einwilligung) {
				if (formModel.Personalisierung) {
					requestModel.TrackingAuthorized = true;
					requestModel.TrackingReferenzId = formModel.TrackingReferenceId;
					requestModel.TrackingVersion = formModel.TrackingConsentVersion;
				}
				if (formModel.CompanyIdentifier) {
					requestModel.Gesellschaftsname = formModel.CompanyIdentifier;
				}
				if (formModel.CompanyIdentifierReferenceCode) {
					requestModel.GesellschaftsId = formModel.CompanyIdentifierReferenceCode;
				}
			}
		}
		return requestModel;
	}

	/**
	 * Converts a view model to an api model.
	 */
	static getPrivacyApiModelFromAdvertisingConsent(formModel: AdvertisingConsentModel): PrivacyApi {
		const requestModel = new PrivacyApi();
		if (formModel !== null && formModel !== undefined) {
			requestModel.Einwilligung = formModel.Einwilligung;
			requestModel.Email = formModel.Email;
			requestModel.Telefon = formModel.Telefon;
			requestModel.TimeStamp = formModel.TimeStamp;
		}
		return requestModel;
	}

	public static getPrivacyAcceptanceApi(werbeZustimmung: WerbeZustimmungModel | AdvertisingConsentModel): PrivacyApi {
		const result = new PrivacyApi();
		if (werbeZustimmung !== null && werbeZustimmung !== undefined) {
			result.Einwilligung = werbeZustimmung.Einwilligung ? PrivacyAcceptanceApi.Agreed : PrivacyAcceptanceApi.Unknown;
			result.Email = werbeZustimmung.Email ? PrivacyAcceptanceApi.Agreed : PrivacyAcceptanceApi.Unknown;
			result.Telefon = werbeZustimmung.Telefon ? PrivacyAcceptanceApi.Agreed : PrivacyAcceptanceApi.Unknown;
		}
		return result;
	}

	/**
	 * Converts a view model to an api model.
	 */
	static getPhoneApi(vorwahl: string | number, nummer: string | number): PhoneApi {
		const phoneModel = new PhoneApi();
		phoneModel.Prefix = null == vorwahl ? null : vorwahl.toString();
		phoneModel.Suffix = null == nummer ? null : nummer.toString();
		return phoneModel;
	}

	static getBankApiFromModel(bankModel: BankdatenModel): BankApi {
		if (null == bankModel) {
			return null;
		}
		const result = new BankApi();

		result.Iban = bankModel.Iban;
		result.Bic = bankModel.Bic;
		result.Bankname = bankModel.Bankname;
		result.BankEinzugMitglied = bankModel.BankEinzugMitglied;
		result.BankEinzugSchutzbrief = bankModel.BankEinzugSchutzbrief;
		result.HatAbwKontoInhaber = bankModel.HatAbweichendenKontoInhaber;
		result.MandateReference = bankModel.MandateReference;
		result.AbwKontoInhaber = this.getAbweichenderKontoInhaberApi(bankModel.AbwKontoInhaber);

		return result;
	}

	static getMitgliedschaftanlagedatenApi(membershipSelection: MembershipSelectionType, werbeschluessel: string): MitgliedschaftanlagedatenApi {
		const result = new MitgliedschaftanlagedatenApi();
		result.Tarif = this.getTarifInfo(membershipSelection);
		result.Werbeschluessel = werbeschluessel;
		return result;
	}

	private static getTarifInfo(membershipSelection: MembershipSelectionType): MglArtApi {
		if (membershipSelection === MembershipSelectionType.NO_MEMBER_BASIS) {
			return MglArtApi.BAS;
		}
		return MglArtApi.PLU;
	}
}